/**
 * MediaPool
 * 画像や動画の保存や管理を行う。
 */
import mediapool from '@/api/mediapool'

export default {
    namespaced: true,
    state: {
        images: [],
        tagImages: [],
        orgImages: [],
        iconImages: [],
        videos: [],
        archiveFlag: false,
        //ModalEditMediaとの連携
        editModalActive: false,
        editModalTarget: {
            type: '',
            data: {},//マウント時エラーを防ぐ仮オブジェクト
            referrers: []
        },
        //ModalSelectMediaとの連携
        selectModalActive: false,
        selectModalType: 'image',// image/video
        selectModalTarget: {
            type: '',
            data: undefined
        },
        isSelected: false,
        isVideoLoading: false,
        isImageLoading: false,
        isVideoSaving: false,
        isImageSaving: false,
        searchWordsBox: [],
        isClickTag:false,
        isClickId:-1,
        isClick: -1,
        isLoading: false,
        selectMediaData: '',
        newImage: null,
    },
    actions: {
        saveImage({ commit }, data ) {
            commit('IMG_SAVING', true)
            mediapool.saveImage(data)
                .then((d) => {
                    commit('SAVE_IMAGE', JSON.parse(d.data))
                    commit('IMG_SAVING', false)
                })
                .catch((e) => {
                    console.error('e: ' + JSON.stringify(e))
                    commit('IMG_SAVING', false)
                })
        },
        saveTagImage({commit}, data) {
            commit('IMG_SAVING', true)
            mediapool.saveTagImage(data)
                .then((d) => {
                    commit('SAVE_TAG_IMAGE', JSON.parse(d.data))
                    commit('IMG_SAVING', false)
                })
                .catch((e) => {
                    console.error('e: ' + JSON.stringify(e))
                    commit('IMG_SAVING', false)
                })
        },
        getAllImages({commit}) {
            commit('IMG_LOADING', true)
            mediapool.getAllImages()
                .then((d) => {
                    if (d.data) {
                        commit('GET_ALL_IMAGES', JSON.parse(d.data))
                    }
                    commit('IMG_LOADING', false)
                })
                .catch((e) => {
                    console.error('e: ' + JSON.stringify(e))
                    commit('IMG_LOADING', false)
                })
        },
        getTagImages({commit}, tag) {
            commit('IMG_LOADING', true)
            mediapool.getTagImages(tag)
                .then((d) => {
                    if (d.data) {
                        commit('GET_TAG_IMAGES', JSON.parse(d.data))
                    }
                    commit('IMG_LOADING', false)
                })
                .catch((e) => {
                    console.error('e: ' + JSON.stringify(e))
                    commit('IMG_LOADING', false)
                })
        },
        getIconOrgImages({commit}) {
            commit('IMG_LOADING', true)
            mediapool.getIconOrgImages()
            .then((d) => {
                if (d.data) {
                    commit('GET_ICON_IMAGES', JSON.parse(d.data))
                }
                commit('IMG_LOADING', false)
            })
            .catch((e) => {
                console.error('e: ' + JSON.stringify(e))
                commit('IMG_LOADING', false)
            })
        },
        getStoryOrgImages({commit}, id) {
            commit('IMG_LOADING', true)
            mediapool.getStoryOrgImages(id)
            .then((d) => {
                if (d.data) {
                    commit('GET_ORG_IMAGES', JSON.parse(d.data))
                }
                commit('IMG_LOADING', false)
            })
            .catch((e) => {
                console.error('e: ' + JSON.stringify(e))
                commit('IMG_LOADING', false)
            })
        },
        deleteImage({commit}, image_id) {
            mediapool.deleteImage(image_id)
                .then ((d) => {
                    commit('DELETE_IMAGE', image_id)
                })
                .catch((e) => {
                    console.error('e: ' + JSON.stringify(e))
                })
        },
        updateImage({commit}, data){
            mediapool.updateImage(data)
                .then((d) => {
                    commit('UPDATE_IMAGE', data)
                })
                .catch((e) => {
                    console.error('e: ' + JSON.stringify(e))
                })
        },
        getImageReferrers({commit}, {id}){
            mediapool.getImageReferrers(id)
                .then((d) => {
                    console.log(d)
                    commit('GET_IMAGE_REF', d.data.message)
                })
        },
        saveVideo({commit}, data) {
            commit('VDO_SAVING', true)
            mediapool.saveVideo(data)
                .then((d) => {
                    commit('VDO_SAVING', false)
                    commit('SAVE_VIDEO', JSON.parse(d.data))
                })
                // .catch((e) => {
                //     commit('VDO_SAVING', false)
                //     console.error('e: ' + JSON.stringify(e))
                // })
        },
        getAllVideos({commit}) {
            commit('IMG_LOADING', true)
            mediapool.getAllVideos()
                .then((d) => {
                    if (d.data) {
                        commit('GET_ALL_VIDEOS', JSON.parse(d.data))
                    }
                    commit('IMG_LOADING', false)
                })
                .catch((e) => {
                    commit('IMG_LOADING', false)
                    console.error('e: ' + JSON.stringify(e))
                })
        },
        deleteVideo({commit}, video_id) {
            mediapool.deleteVideo(video_id)
                .then ((d) => {
                    commit('DELETE_VIDEO', video_id)
                })
                .catch((e) => {
                    console.error('e: ' + JSON.stringify(e))
                })
        },
        updateVideo({commit}, data){
            mediapool.updateVideo(data)
                .then((d) => {
                    commit('UPDATE_VIDEO', data)
                })
                .catch((e) => {
                    console.error('e: ' + JSON.stringify(e))
                })
        },
        getVideoReferrers({commit}, {id}){
            mediapool.getVideoReferrers(id)
                .then((d) => {
                    commit('GET_VIDEO_REF', d.data.message)
                })
        },
        openEditModal({commit}, {type, idx, flg}) {
            commit('OPEN_EDIT_MODAL', {type, idx, flg})
        },
        openMultiEditModal({commit}, {type, data, flg}) {
            commit('OPEN_MULTI_EDIT_MODAL', {type, data, flg})
        },
        closeEditModal({commit}) {
            commit('CLOSE_EDIT_MODAL')
        },
        openSelectModal({commit}, {type}) {
            commit('OPEN_SELECT_MODAL', {type})
        },
        closeSelectModal({commit}){
            commit('CLOSE_SELECT_MODAL')
        },
        selectMedia({commit}, pk) {
            commit('SELECT_MEDIA', pk)
        },
        searchWordsInitial({commit}, {tag,tagList}){
            commit('SEARCH_WORDS_INITIAL', {tag,tagList})
        },
        isClickTag({commit}, {type,flg,id,tagList}){
            commit('IS_CLICK_TAG', {type,flg,id,tagList})
        },
        updateOrderImage ({commit}, data) {
            mediapool.updateOrderImage(data)
                .catch((e) => {
                    alert('エラーが発生いたしました')
                })
        },
        updateOrderVideo ({commit}, data) {
            mediapool.updateOrderVideo(data)
                .catch((e) => {
                    alert('エラーが発生いたしました')
                })
        }
    },
    mutations: {
        IMG_LOADING (state, flg) {
            state.isImageLoading = flg
        },
        VDO_LOADING (state, flg) {
            state.isVideoLoading = flg
        },
        IMG_SAVING (state, flg) {
            state.isImageSaving = flg
        },
        VDO_SAVING (state, flg) {
            state.isVideoSaving = flg
            if (state.isVideoSaving) {
                state.isLoading = true
            } else {
                state.isLoading = false
            }
        },
        SAVE_IMAGE (state, data) {
            state.images.unshift(data)
            state.selectMediaData = data.pk
        },
        SAVE_TAG_IMAGE (state, data) {
            state.tagImages.unshift(data)
            state.newImage = data
        },
        GET_ALL_IMAGES (state, images) {
            state.images = images
            state.images.sort((a, b) => {
                return a.image_order - b.image_order
            })
            for (var i in state.images) {
                state.images[i].image_order = i
            }
        },
        GET_TAG_IMAGES (state, images) {
            state.tagImages = images.reverse()
        },
        GET_ORG_IMAGES (state, images) {
            state.orgImages = images
        },
        GET_ICON_IMAGES (state, images) {
            state.iconImages = images
        },
        DELETE_IMAGE (state, image_id) {
            for (var idx = 0;idx < state.images.length; idx++) {
                if (state.images[idx].image_id === image_id) {
                    state.images.splice(idx, 1)
                    break
                }
            }
            for (var idx = 0;idx < state.tagImages.length; idx++) {
                if (state.tagImages[idx].image_id === image_id) {
                    state.tagImages.splice(idx, 1)
                    break
                }
            }
        },
        UPDATE_IMAGE (state, data) {
            for (var idx = 0;idx < state.images.length; idx++) {
                if (state.images[idx].image_id === data.image_id) {
                    state.images.splice(idx, 1, data)
                    break
                }
            }
            for (var idx = 0;idx < state.tagImages.length; idx++) {
                if (state.tagTmages[idx].image_id === data.image_id) {
                    state.tagImages.splice(idx, 1, data)
                    break
                }
            }
        },
        GET_IMAGE_REF (state, mes) {
            state.editModalTarget.referrers = mes
        },
        SAVE_VIDEO (state, data) {
            state.videos.sort((a, b) => {
                return a.video_order - b.video_order
            })
            state.videos.unshift(data)
        },
        GET_ALL_VIDEOS (state, videos) {
            state.videos = videos
            state.videos.sort((a, b) => {
                return a.video_order - b.video_order
            })
        },
        DELETE_VIDEO (state, video_id) {
            for (var idx = 0;idx < state.videos.length; idx++) {
                if (state.videos[idx].video_id === video_id) {
                    state.videos.splice(idx,1)
                    break
                }
            }
        },
        UPDATE_VIDEO (state, data) {
            for (var idx = 0; idx < state.videos.length; idx++) {
                if (state.videos[idx].video_id === data.video_id) {
                    state.videos.splice(idx, 1, data)
                    break
                }
            }
        },
        GET_VIDEO_REF(state, mes) {
            state.editModalTarget.referrers = mes
        },
        OPEN_EDIT_MODAL (state, {type, idx, flg}) {
            state.editModalTarget.type = type
            if (type == 'image') {
                for (let image of state.images) {
                    if (image.image_order == idx) {
                        state.editModalTarget.data = image
                    }
                }
            }
            else if (type == 'video') {
                for (let video of state.videos) {
                    if (video.video_order == idx) {
                        state.editModalTarget.data = video
                    }
                }
            }
            state.editModalActive = true
            state.isSelected = false
            state.archiveFlag = flg
        },
        OPEN_MULTI_EDIT_MODAL (state, {type, data, flg}) {
            state.editModalTarget.type = type
            state.editModalTarget.data = data
            state.editModalActive = true
            state.isSelected = false
            state.archiveFlag = flg
        },
        CLOSE_EDIT_MODAL (state) {
            state.editModalActive = false
            state.editModalTarget.referrers = []
        },
        OPEN_SELECT_MODAL (state, {type}){
            state.selectModalActive = true
            state.selectModalType = type
            state.isSelected = false
        },
        CLOSE_SELECT_MODAL (state) {
            state.selectModalActive = false
        },
        SELECT_MEDIA (state, pk) {
            state.isSelected = true
            state.selectModalTarget.type = state.selectModalType
            if (state.selectModalType === 'image') {
                for (let i of state.images) {
                    if (i.pk === pk) state.selectModalTarget.data = i
                }
            } else if (state.selectModalType === 'video') {
                for (let v of state.videos) {
                    if (v.pk === pk) state.selectModalTarget.data = v
                }
            }
            console.log(state.selectModalTarget)
        },
        SEARCH_WORDS_INITIAL(state, {tag,tagList}){
            state.searchWordsBox = []
            function searchLanguage (str) {
                var eng = new RegExp(/^[a-zA-Z]*$/);
                var jap = new RegExp(/^[ぁ-んー　]*$/);
                if(eng.test(str)){
                    return "english"
                } else if (jap.test(str)){
                    return "japanese"
                } else {
                    return "noLanguage"
                }
            }
            var tagBox = []
            var tagBox2 = []
        
            if (searchLanguage(tag) == "english") {
                for (var i in tagList) {
                    tagBox.push([tagList[i][2].indexOf(tag), i])
                }
            } else if (searchLanguage(tag) == "japanese") {
                for(var i in tagList){
                    tagBox.push([tagList[i][1].indexOf(tag), i])
                }
            } else {
                for (var i in tagList){
                    tagBox.push([tagList[i][0].indexOf(tag), i])
                }
            }

            for (var i in tagBox) {
                if (tagBox[i][0] != -1) {
                    tagBox2.push(tagBox[i])
                }
            }
        
            tagBox2.sort(function(a,b){return(a[0] - b[0]);});
        
            for (var i in tagBox2) {
                state.searchWordsBox.push(tagList[tagBox2[i][1]])
            }
        },
        IS_CLICK_TAG (state, {type,flg,id,tagList}) {
            state.searchWordsBox=[]
            state.searchWordsBox = tagList
            state.isClickTag=flg
            state.isClickId=id
            if (type=='image') {
                for (var idx = 0; idx < state.images.length; idx++) {
                    if (state.images[idx].image_id === id) {
                        state.isClick = idx
                    }
                }
            }
            else if (type=='video') {
                for (var idx = 0; idx < state.videos.length; idx++) {
                    if (state.videos[idx].video_id === id) {
                        state.isClick = idx
                    }
                }
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/mediapool.js